import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const apiClient = axios.create({ baseURL: API });

export const getAdminToken = () => localStorage.getItem("mha_admin_token");
export const setAdminToken = (t) => localStorage.setItem("mha_admin_token", t);
export const clearAdminToken = () => localStorage.removeItem("mha_admin_token");

export const adminClient = axios.create({ baseURL: API });
adminClient.interceptors.request.use((config) => {
  const token = getAdminToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(err, fallback = "Something went wrong. Please try again.") {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg).filter(Boolean).join(" ");
  return fallback;
}
